// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2y6cs","select":"Header_select__11C3A","clinic":"Header_clinic__3Qwyf"};